import { c as _c } from "react/compiler-runtime";
import { FaroBulkDialog } from "@components/common/faro-table/bulk-dialog/bulk-dialog";
import { BulkSuccessDialog } from "@components/common/faro-table/bulk-dialog/bulk-success-dialog";
import { AccessLevelMenuButton } from "@components/access-level/access-level-menu-button";
import { useChangeAccessLevelBulkDialogContent } from "@components/table/projects/bulk-actions/bulk-change-access-level-helper";
import { updateProjectDetails } from "@store/projects/projects-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { bulkActionNameSelector, selectedEntitiesSelector, shouldShowSuccessDialogSelector } from "@store/table/table-selector";
import { setBulkActionName } from "@store/table/table-slice";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useEffect, useState } from "react";

/** Button allowing to change project access level in company */
export function BulkChangeProjectAccessLevel() {
  const $ = _c(21);
  const [shouldShowDialog, setShouldShowDialog] = useState(false);
  const [newAccessLevel, setNewAccessLevel] = useState("private");
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  const dispatch = useAppDispatch();
  const shouldShowSuccessDialog = useAppSelector(shouldShowSuccessDialogSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = selectedEntitiesSelector("projects");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const selectedEntities = useAppSelector(t0);
  const {
    bulkDialogContent,
    successDialogContent
  } = useChangeAccessLevelBulkDialogContent("project", newAccessLevel);
  let t1;
  let t2;
  if ($[1] !== shouldShowSuccessDialog) {
    t1 = () => {
      if (shouldShowSuccessDialog) {
        setShouldShowDialog(false);
      }
    };
    t2 = [shouldShowSuccessDialog];
    $[1] = shouldShowSuccessDialog;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== dispatch) {
    const onAccessLevelChange = function onAccessLevelChange(accessLevel) {
      dispatch(setBulkActionName("changeAccessLevel"));
      setNewAccessLevel(accessLevel);
      setShouldShowDialog(true);
    };
    t3 = <AccessLevelMenuButton type="project" onAccessLevelChange={onAccessLevelChange} />;
    $[4] = dispatch;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== bulkActionName || $[7] !== shouldShowSuccessDialog || $[8] !== successDialogContent) {
    t4 = bulkActionName === "changeAccessLevel" && shouldShowSuccessDialog && <BulkSuccessDialog dialogContent={successDialogContent} />;
    $[6] = bulkActionName;
    $[7] = shouldShowSuccessDialog;
    $[8] = successDialogContent;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== bulkActionName || $[11] !== bulkDialogContent || $[12] !== dispatch || $[13] !== newAccessLevel || $[14] !== selectedEntities || $[15] !== shouldShowDialog) {
    t5 = bulkActionName === "changeAccessLevel" && shouldShowDialog && <FaroBulkDialog dialogContent={bulkDialogContent} onClose={() => setShouldShowDialog(false)} trackingEvent={BulkActionEvents.bulkChangeGroup} bulkActionCallback={project => dispatch(updateProjectDetails({
      projectId: project.id,
      payload: {
        accessLevel: newAccessLevel
      }
    })).unwrap()} selectedEntities={selectedEntities} uniqueIdKey="id" tableDataType="projects" />;
    $[10] = bulkActionName;
    $[11] = bulkDialogContent;
    $[12] = dispatch;
    $[13] = newAccessLevel;
    $[14] = selectedEntities;
    $[15] = shouldShowDialog;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}